"use client";

import { useParams } from "next/navigation";

/**
 * Hook to get the organization slug from the URL
 * Assumes URL structure: /[orgSlug]/...
 */
const useOrgSlug = (): string => {
  const { orgSlug } = useParams();
  return orgSlug as string;
};

export default useOrgSlug;
